/**
 * TextInput.
 */

/**
 * External dependencies.
 */
import { useState, useEffect } from 'react';

function TextInput({
	autocomplete = null,
	label,
	minlength = null,
	maxlength = null,
	name,
	onChange,
	pattern = null,
	required = false,
	disabled = false,
	value,
	error = false,
}) {
	const [ isActive, setIsActive ] = useState( value ?? false );
	const [ used, setUsed ] = useState( false );

	const classes = [
		'dpf_text',
		used && 'dpf_text--used',
		isActive && 'dpf_text--active',
		error && 'dpf_text--error',
	];

	useEffect( () => {
		setIsActive( value ?? false );
	}, [value] );

	const handleOnBlur = () => {
		setUsed( true )
		! value && setIsActive( false )
	}

	return (
		<div className={classes.filter(Boolean).join(' ')}>
			<label className="dpf_text__label" htmlFor={name}>
				{label}
				{ required &&
					<span className="dpf_required">*</span>
				}
			</label>
			<input
				aria-required={required}
				autoComplete={autocomplete}
				className="dpf_text__input"
				id={name}
				maxLength={maxlength}
				minLength={minlength}
				name={name}
				onBlur={() => handleOnBlur()}
				onChange={(e) => onChange(e.target.value)}
				onFocus={() => setIsActive( true )}
				pattern={pattern}
				required={required}
				type="text"
				value={value}
				disabled={disabled}
			/>
			{ error &&
				<div>
					{error.map((message) => {
						return (
							<>{message}</>
							
						)
					})}
				</div>
			}
		</div>
	)
};

export default TextInput;
